import { useEffect, useState } from "react";
import BASEURL from "../../../Utils/Baseurl";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import Swal from "sweetalert2";
import "./File.css";
import axios from "axios";
import IosShareIcon from "@mui/icons-material/IosShare";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { useLoading } from "../../../../context/loading";
import request, { gql } from "graphql-request";

const AddPayroll = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const statedata = location?.state?.data;

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [employee, setEmplyoee] = useState({});
  const [employeeSalaryList, setEmployeeSalaryList] = useState([]);

  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  const startYear = 2000;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }
  const yearOptions = years.map((year) => ({
    value: year,
    label: year.toString(),
  }));

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear.toString(),
  });
  const [selectedMonth, setSelectedMonth] = useState({
    value: currentMonth + 1,
    label: monthNames[currentMonth],
  });

  const currentMonths = new Date().getMonth();

  const monthOptions = () => {
    let month;
    if (selectedYear?.value) {
      if (currentYear == selectedYear?.value) {
        month = monthNames.slice(0, currentMonths + 1).map((month, index) => ({
          value: index + 1,
          label: month,
        }));
      } else {
        month = monthNames.map((month, index) => ({
          value: index + 1,
          label: month,
        }));
      }
    } else {
      month = monthNames.map((month, index) => ({
        value: index + 1,
        label: month,
      }));
    }
    return month;
  };

  //Excel handle

  const handleExportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(EarningListTable.rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Earnings Report");

    // Convert to binary and save
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(data, "EarningsReport.xlsx");
  };

  // handle Table

  const EarningListTable = {
    columns: [
      { field: "id", headerName: "S No", width: 80, sortable: true },
      { field: "action", headerName: "Pay Slip", width: 130, sortable: true },
      {
        field: "employeeId",
        headerName: "Employee ID",
        width: 130,
        sortable: true,
      },
      {
        field: "employeeName",
        headerName: "Employee Name",
        width: 130,
        sortable: true,
      },
      {
        field: "accountNumber",
        headerName: "Account Number",
        width: 130,
        sortable: true,
      },
      {
        field: "employeeCategory",
        headerName: "Employee Category",
        width: 150,
        sortable: true,
      },
      {
        field: "esiNumber",
        headerName: "ESI Number",
        width: 130,
        sortable: true,
      },
      {
        field: "pfNumber",
        headerName: "PF Number",
        width: 130,
        sortable: true,
      },
      {
        field: "monthDays",
        headerName: "Month Days",
        width: 130,
        sortable: true,
      },
      {
        field: "salaryDays",
        headerName: "Salary Days",
        width: 130,
        sortable: true,
      },
      {
        field: "absentDays",
        headerName: "Absent Days",
        width: 130,
        sortable: true,
      },
      {
        field: "basicPay",
        headerName: "Basic Pay",
        width: 130,
        sortable: true,
      },
      {
        field: "daAllowance",
        headerName: "DA Allowance",
        width: 130,
        sortable: true,
      },
      {
        field: "attendanceAllowance",
        headerName: "Attendance Allowance",
        width: 170,
        sortable: true,
      },
      {
        field: "mealsDays",
        headerName: "Meals Days",
        width: 130,
        sortable: true,
      },
      {
        field: "shiftPaiseDays",
        headerName: "Shift Paise Days",
        width: 140,
        sortable: true,
      },
      { field: "otHours", headerName: "OT Hours", width: 130, sortable: true },
      {
        field: "earnedBasic",
        headerName: "Earned Basic",
        width: 130,
        sortable: true,
      },
      {
        field: "earnedDA",
        headerName: "Earned DA",
        width: 130,
        sortable: true,
      },
      {
        field: "lopAmount",
        headerName: "LOP Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "otAmount",
        headerName: "OT Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "shiftPaiseAmount",
        headerName: "Shift Paise Amount",
        width: 150,
        sortable: true,
      },
      { field: "busFare", headerName: "Bus Fare", width: 130, sortable: true },
      {
        field: "grossPay",
        headerName: "Gross Pay",
        width: 130,
        sortable: true,
      },
      {
        field: "esiAmount",
        headerName: "ESI Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "pfAmount",
        headerName: "PF Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "totalAmount",
        headerName: "Total Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "advanceAmount",
        headerName: "Advance Amount",
        width: 130,
        sortable: true,
      },
      { field: "netPay", headerName: "Net Pay", width: 130, sortable: true },
    ],
    rows: employeeSalaryList?.map((addItem, ind) => ({
      id: addItem?.id,
      employeeId: addItem?.employee?.empid,
      employeeName:
        addItem?.employee?.firstName + " " + addItem?.employee?.lastName,
      accountNumber: addItem?.employee?.bankDetails?.accountNumber,
      employeeCategory: addItem?.employee?.category,
      esiNumber: addItem?.employee?.esicNumber,
      pfNumber: addItem?.employee?.uanNumber,
      monthDays: addItem?.monthDays,
      salaryDays: addItem?.salaryDays,
      absentDays: addItem?.absentDays,
      basicPay: addItem?.basicAmount,
      daAllowance: addItem?.daAmount,
      attendanceAllowance: addItem?.attendanceAllowance,
      mealsDays: addItem?.mealsDays,
      shiftPaiseDays: addItem?.shiftPaiseDays,
      otHours: addItem?.otHours,
      earnedBasic: addItem?.earnedBasic,
      earnedDA: addItem?.earnedDa,
      lopAmount: addItem?.lopAmount,
      otAmount: addItem?.otAmount,
      shiftPaiseAmount: addItem?.shiftPaiseAmount,
      busFare: addItem?.busFare,
      grossPay: addItem?.grossPay,
      esiAmount: addItem?.esiAmount,
      pfAmount: addItem?.pfAmount,
      totalAmount: addItem?.totalAmount,
      advanceAmount: addItem?.advanceAmount,
      netPay: addItem?.netPay,
      action: (
        <>
          <button
            onClick={() => navigate("/payroll/payslip", { state: addItem })}
          >
            Download
          </button>
        </>
      ),
    })),
  };

  const employeeAndId = gql`
    query {
      allUsersDetail {
        id
        firstName
        empid
        email
        category
      }
    }
  `;

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        const resp = await request(BASEURL, employeeAndId);

        if (resp?.allUsersDetail) {
          const formattedEmployees = resp.allUsersDetail.map((user) => ({
            value: user.id,
            label: user.firstName,
            empid: user.empid,
            category: user.category,
          }));

          setEmployeeOptions(formattedEmployees);
        }
      } catch (error) {
        console.error("Error fetching Employee Details", error);
      }
    };

    fetchEmployeeDetails();
  }, []);

  const onSalaryStructureSubmit = async () => {
    const query = `
   query GetAllPayrolls($category: String, $month: Int, $year: Int, $branch: String) {
  allPayrolls(category: $category, month: $month, year: $year, branch: $branch) {
    id
    employee {
      id
      firstName
      lastName
      empid
      branch
      category
      dateOfJoining
      employeeType
      uanNumber
      esicNumber
      bankDetails{
        accountNumber
        ifscNumber
        cifNumber
        branchName
      	bankName
      }
    }
    month
    year
    monthDays
    salaryDays
    absentDays
    mealsDays
    shiftPaiseDays
    otHours
    basicAmount
    daAmount
    mealsAmountPerDay
    otAmountPerHour
    shiftPaisa
    attendanceAmount
    busFare
    esiAmount
    pfAmount
    advanceAmount
    bonusAmount
    earnedBasic
    earnedDa
    lopAmount
    otAmount
    shiftPaiseAmount
    attendanceAllowance
    mealsAmount
    grossPay
    totalAmount
    netPay
  }
}
        `;
    setCirleLoading(true);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            category: statedata?.category,
            month: statedata?.month,
            year: statedata?.year,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data?.allPayrolls;
      setEmployeeSalaryList(data);
    } catch (error) {
      console.error("ResponseError:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (statedata) {
      onSalaryStructureSubmit();
      setTogglePage({
        ...togglePage,
        view: true,
      });
    }
  }, []);

  // handel submit
  const payrollSubmit = async () => {
    const query = `
   mutation CreatePayroll($month: Int!, $year: Int!, $category: String, $employeeId:ID) { 
  createPayroll(month: $month, year: $year, category: $category, employeeId:$employeeId) { 
   	success 
    message 
    payrolls { 
      employee { 
        id 
        firstName 
        empid 
        branch 
        category 
      } 
      month 
      year 
      monthDays 
      salaryDays 
      absentDays 
      mealsDays 
      shiftPaiseDays 
      otHours 
      basicAmount 
      daAmount 
      mealsAmountPerDay 
      otAmountPerHour 
      shiftPaisa 
      attendanceAmount 
      busFare 
      esiAmount 
      pfAmount 
      advanceAmount  
      bonusAmount 
      earnedBasic 
      earnedDa 
      lopAmount 
      otAmount 
      shiftPaiseAmount 
      busFare 
      attendanceAllowance 
      mealsAmount 
      grossPay 
      totalAmount 
      netPay 
    } 
  } 
}    
      `;
    setCirleLoading(true);
    try {
      const variables = {
        month: selectedMonth?.value,
        year: selectedYear?.value,
        employeeId: employee?.value,
      };

      const response = await axios.post(
        BASEURL,
        {
          query,
          variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.data?.createPayroll.success == false) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response.data.data.createPayroll?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (response?.data?.data?.createPayroll?.payrolls.length > 0) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Payroll Created Successfully",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/payroll");
      } else if (response?.data?.data?.createPayroll?.payrolls.length == 0) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "No Data Found",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error.message);
    } finally {
      setCirleLoading(false);
    }
  };

  // handel disable function

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      selectedMonth !== "" &&
      selectedYear !== ""
      // && EmpcategoryData !== ""
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //handel submit
  const handleAddPayroll = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "You can't edit the payroll once it is executed,are you sure to execute?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        payrollSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //handel cancel
  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/payroll");
  };
  const handleclose = () => {
    navigate("/payroll");
  };
  console.log(employee, "payrollData?.employee?.value");
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ overflow: "visible" }}>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              padding={1}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {togglePage.view ? "View Payroll" : "Add Payroll"}
                </MaterialTypography>
              </Stack>
              {togglePage.view && (
                <ButtonGroup variant="outlined" aria-label="button group">
                  <MaterialButton
                    variant="gradient"
                    style={{ backgroundColor: "green", color: "white" }}
                    startIcon={<IosShareIcon />}
                    onClick={handleExportToExcel}
                  >
                    Export
                  </MaterialButton>
                  <MaterialButton
                    sx={{ marginLeft: "3px" }}
                    variant="gradient"
                    color="dark"
                    onClick={() => navigate("/payroll/payslip")}
                  >
                    All Payslip
                  </MaterialButton>
                </ButtonGroup>
              )}
            </Stack>
          }
        />
        <CardContent>
          {!togglePage.view && (
            <MaterialBox>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, sm: 12, lg: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Year <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="year"
                    options={yearOptions}
                    value={selectedYear}
                    onChange={(year) => setSelectedYear(year)}
                    customStyles={{ optionPadding: 20 }}
                    // isClearable
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, lg: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Month <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="month"
                    options={monthOptions()}
                    value={selectedMonth}
                    onChange={(month) => setSelectedMonth(month)}
                    customStyles={{ optionPadding: 20 }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, lg: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Employee
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="emplyoee"
                    options={employeeOptions}
                    value={employee}
                    onChange={(e) => setEmplyoee(e)}
                    customStyles={{ optionPadding: 20 }}
                  />
                </Grid>
              </Grid>
            </MaterialBox>
          )}
          {togglePage.view && (
            <>
              <MaterialTypography
                sx={{ mt: 3, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                variant="h5"
                fontWeight="bold"
              >
                Payroll Details
              </MaterialTypography>

              <MaterialDataGrid
                rows={EarningListTable.rows}
                columns={EarningListTable.columns}
                checkboxSelection={false}
                isSelectable={false}
                localeText={{
                  noRowsLabel: (
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      spacing={1}
                    >
                      <MaterialTypography
                        variant="body2"
                        fontWeight="medium"
                        color="text"
                      >
                        No details found
                      </MaterialTypography>
                    </Stack>
                  ),
                }}
                customHeight="100%"
                noSearch
                noPagination
                pageSize={5}
                rowsPerPageOptions={[5, 10, 25]}
              />
            </>
          )}
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <>
            {togglePage.view ? (
              <MaterialButton
                sx={{ m: 2, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                onClick={handleclose}
              >
                Close
              </MaterialButton>
            ) : (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handlecancel}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2, marginLeft: "4px" }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddPayroll}
                >
                  Submit
                </MaterialButton>
              </>
            )}
          </>
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default AddPayroll;
